<template>
    <div
            class="dropdown"
            :class="{ 'show': isDropdownActive }"
            v-on-clickaway="away"
            v-show="this.localOptions.length > 0"
    >
      <div class="title">{{ this.localTitle }}</div>
        <button
                class="btn btn--green dropdown-toggle"
                type="button" id="dropdownMenuButton"
                aria-haspopup="true"
                :aria-expanded="isDropdownActive ? 'true' : 'false'"
                @click.prevent="isDropdownActive=!isDropdownActive"
        >
            <span class="d-none d-sm-inline">{{ getTitlePrefix() }}</span> <span>{{ getTitleSuffix() }}</span>
        </button>
        <div
                class="dropdown-menu"
                :class="{ 'show': isDropdownActive }"
                :style="{ 'position: absolute; transform: translate3d(0px, 37px, 0px); top: 0px; left: 0px; will-change: transform;' : isDropdownActive }"
        >
          <a href="#" class="dropdown-item" @click.prevent="selectItem(0)">--- не нужно</a>
            <a
                href="#"
                v-for="option in localOptions"
                :key="option.id"
                class="dropdown-item aligned"
                :class="getClass(option.selected)"
                @click.prevent="selectItem(option.id)"
            >
                <img :src="option.image" class="option_image" />
                <div>
                    <span class="d-none d-sm-block">{{ option.dname }}</span> {{ option.article }} {{ option.count}}шт <span class="price">{{ option.price}}р</span>
                    <div class="message" v-show="option.message != ''">{{ option.message}}</div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
    // watch click out of the element
    import { mixin as clickaway } from 'vue-clickaway';
    export default {
        name: "dropdown-element",
        props: ['id', 'title', 'options', 'session_key'],
        mixins: [ clickaway ],
        data() {
            return {
                isDropdownActive: false,
                localOptions: this.options,
                localTitle: this.title,
                localSessionKey: this.session_key
            }
        },
        methods: {
            away() {
                this.isDropdownActive = false;
            },
            getClass(is_sel) {
              return (is_sel) ? 'active' : '';
            },
            getTitlePrefix() {
                if(!Array.isArray(this.localOptions)) {
                  return '';
                }
                let selected_item = this.localOptions.filter(function (item) {
                    return item.selected == true;
                })

                if(selected_item.length === 0) {
                    return '';
                }

                return selected_item[0].dname;
            },
            getTitleSuffix() {
                if(!Array.isArray(this.localOptions)) {
                  return 'выбрать ' + this.localTitle;
                }
                let selected_item = this.localOptions.filter(function (item) {
                    return item.selected == true;
                })

                if(selected_item.length === 0) {
                    return 'выбрать ' + this.localTitle;
                }

                return selected_item[0].article;
            },
             selectItem(option_id) {
              // set session
              this.$store.dispatch(
                  'selectBundleItem',
                  {
                    session_key: this.localSessionKey,
                    id: this.id,
                    option_id: option_id
                  }
              )
              this.localOptions.forEach(function (item, index, arr) {
                arr[index].selected = (option_id==item.id) ? true : false
              });

              this.isDropdownActive = false;
            }
        },
        mounted() {
            Evnt.listen('ResetDropdown', (payload) => {
                if(payload === this.localSessionKey) {
                    this.selectItem(0)
                }
            })
        }
    }
</script>

<style scoped>
  .title {
    font-size: 12px;
    font-weight: bold;
    padding-top: 10px;
    text-transform: uppercase;
  }
    .option_image {
        width: 50px;
        margin-right: 5px;
    }
    .aligned {
        display: flex;
        align-items: center;
    }
    .price {
        font-weight: bold;
        margin-left: 5px;
    }
    .message {
        color: #FF0000;
    }
</style>
